import { FuseAnimate, FusePageCarded } from '@fuse';
import _ from '@lodash';
import { Typography, withStyles } from '@material-ui/core';
import XAPPAcoesTela from 'app/Core/Components/AcoesTela/XAPPAcoesTela';
import CatchErro from 'app/Core/Components/CatchErro/CatchErro';
import FilterApp from 'app/Core/Components/Filter/FilterApp';
import PainelToggleButton from 'app/Core/Components/Filter/PainelToggleButton';
import XAPPComponent from 'app/Core/Components/XAPPComponent/XAPPComponent';
import withReducer from 'app/store/withReducer';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import ChaveDialog from './ChaveDialog';
import ChaveList from './ChaveList';
import * as Actions from './Store/Actions/ChaveActions';
import reducer from './Store/Reducers/ChaveReducer';

const filterApp = [
    { "label": "Descrição", "value": "chave.descricao", "tipo": "string" },
    { "label": "Código", "value": "chave.codigo", "tipo": "string" }
]

const styles = theme => ({
    addButton: {
        position: 'absolute',
        right: 20,
        bottom: 20,
        zIndex: 99,
        color: theme.palette.text.primary,
    }
});

class ChaveApp extends XAPPComponent {

    state = {
        acoes: null
    }

    getAcoes = (_AValue) => {
        return this.state.acoes;
    }

    setAcoes = (_AValue) => {
        this.setState({ acoes: _AValue });
    }

    listFilter = (_AFilter) => {
        const { tipo } = this.props;
        const xappRouteParams = this.props.match.params;
        let AFiltro = Object.assign({}, _AFilter);
        if (_.isUndefined(AFiltro.AND) || _.isNull(AFiltro.AND)) {
            AFiltro.AND = [];
        }
        AFiltro.AND.push({ Campo: "tipo", Operador: "=", Valor: tipo });
        this.props.list("SELECIONAR", xappRouteParams, AFiltro);
    }

    render() {
        const xappRouteParams = this.props.match.params;
        const { acoes } = this.state;
        const { Label, tipo } = this.props;

        return (
            <React.Fragment>
                <CatchErro
                    url={this.props.match.url}
                >
                    <FusePageCarded
                        classes={{
                            contentWrapper: "p-0",
                            contentCardWrapper: "p-16 sm:p-24 pb-80",
                            leftSidebar: "w-256 border-0",
                            header: "w-full min-h-48 h-48 max-h-48 flex",
                            topBg: "min-h-48 h-48"
                        }}
                        header={
                            <div className="w-full flex items-center">
                                <FuseAnimate animation="transition.slideLeftIn" delay={300}>
                                    <Typography className=" sm:flex text-white" variant="h6">{Label}</Typography>
                                </FuseAnimate>
                                <div className="flex-1" />
                                <PainelToggleButton />
                                <FilterApp
                                    filters={filterApp}
                                    xappRouteParams={xappRouteParams}
                                    pesquisar={this.listFilter}
                                />
                            </div>
                        }
                        content={
                            <ChaveList
                                xappRouteParams={xappRouteParams}
                                setAcoes={this.setAcoes}
                                getAcoes={this.getAcoes}
                                tipo={tipo}
                                listFilter={this.listFilter}
                            />
                        }
                        sidebarInner
                        onRef={instance => {
                            this.pageLayout = instance;
                        }}
                        innerScroll
                    />
                    {acoes !== null &&
                        <XAPPAcoesTela>
                            {acoes}
                        </XAPPAcoesTela>
                    }
                    <ChaveDialog
                        xappRouteParams={xappRouteParams}
                        tipo={tipo}
                    />
                </CatchErro>
            </React.Fragment>
        )
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        list: Actions.list,
    }, dispatch);
}

function mapStateToProps({ Chave }) {
    return {
        Chave: Chave,
    }
}

export default withReducer('Chave', reducer)(withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(ChaveApp))));
